function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_15372",
  "data-name": "Group 15372",
  transform: "translate(0.5 0.5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_14991",
  "data-name": "Group 14991"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_14990",
  "data-name": "Group 14990"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_23937",
  "data-name": "Path 23937",
  d: "M17.656,1.563h-.937V0H15.156V1.563H4.844V0H3.281V1.563H2.344A2.346,2.346,0,0,0,0,3.906v13.75A2.346,2.346,0,0,0,2.344,20H17.656A2.346,2.346,0,0,0,20,17.656V3.906A2.346,2.346,0,0,0,17.656,1.563Zm.781,16.094a.782.782,0,0,1-.781.781H2.344a.782.782,0,0,1-.781-.781V7.344H18.438Zm0-11.875H1.563V3.906a.782.782,0,0,1,.781-.781h.938V4.688H4.844V3.125H15.156V4.688h1.563V3.125h.938a.782.782,0,0,1,.781.781Z",
  fill: "#95A1B2",
  stroke: "rgba(0,0,0,0)",
  strokeWidth: 1
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_14993",
  "data-name": "Group 14993",
  transform: "translate(2.969 8.984)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_14992",
  "data-name": "Group 14992"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1571",
  "data-name": "Rectangle 1571",
  width: 1.563,
  height: 1.563,
  fill: "#95A1B2",
  stroke: "rgba(0,0,0,0)",
  strokeWidth: 1
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_14995",
  "data-name": "Group 14995",
  transform: "translate(6.094 8.984)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_14994",
  "data-name": "Group 14994"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1572",
  "data-name": "Rectangle 1572",
  width: 1.563,
  height: 1.563,
  fill: "#95A1B2",
  stroke: "rgba(0,0,0,0)",
  strokeWidth: 1
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_14997",
  "data-name": "Group 14997",
  transform: "translate(9.219 8.984)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_14996",
  "data-name": "Group 14996"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1573",
  "data-name": "Rectangle 1573",
  width: 1.563,
  height: 1.563,
  fill: "#95A1B2",
  stroke: "rgba(0,0,0,0)",
  strokeWidth: 1
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_14999",
  "data-name": "Group 14999",
  transform: "translate(12.344 8.984)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_14998",
  "data-name": "Group 14998"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1574",
  "data-name": "Rectangle 1574",
  width: 1.563,
  height: 1.563,
  fill: "#95A1B2",
  stroke: "rgba(0,0,0,0)",
  strokeWidth: 1
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_15001",
  "data-name": "Group 15001",
  transform: "translate(15.469 8.984)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_15000",
  "data-name": "Group 15000"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1575",
  "data-name": "Rectangle 1575",
  width: 1.563,
  height: 1.563,
  fill: "#95A1B2",
  stroke: "rgba(0,0,0,0)",
  strokeWidth: 1
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_15003",
  "data-name": "Group 15003",
  transform: "translate(2.969 12.109)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_15002",
  "data-name": "Group 15002"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1576",
  "data-name": "Rectangle 1576",
  width: 1.563,
  height: 1.563,
  fill: "#95A1B2",
  stroke: "rgba(0,0,0,0)",
  strokeWidth: 1
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_15005",
  "data-name": "Group 15005",
  transform: "translate(6.094 12.109)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_15004",
  "data-name": "Group 15004"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1577",
  "data-name": "Rectangle 1577",
  width: 1.563,
  height: 1.563,
  fill: "#95A1B2",
  stroke: "rgba(0,0,0,0)",
  strokeWidth: 1
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_15007",
  "data-name": "Group 15007",
  transform: "translate(9.219 12.109)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_15006",
  "data-name": "Group 15006"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1578",
  "data-name": "Rectangle 1578",
  width: 1.563,
  height: 1.563,
  fill: "#95A1B2",
  stroke: "rgba(0,0,0,0)",
  strokeWidth: 1
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_15009",
  "data-name": "Group 15009",
  transform: "translate(12.344 12.109)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_15008",
  "data-name": "Group 15008"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1579",
  "data-name": "Rectangle 1579",
  width: 1.563,
  height: 1.563,
  fill: "#95A1B2",
  stroke: "rgba(0,0,0,0)",
  strokeWidth: 1
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_15011",
  "data-name": "Group 15011",
  transform: "translate(2.969 15.234)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_15010",
  "data-name": "Group 15010"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1580",
  "data-name": "Rectangle 1580",
  width: 1.563,
  height: 1.563,
  fill: "#95A1B2",
  stroke: "rgba(0,0,0,0)",
  strokeWidth: 1
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_15013",
  "data-name": "Group 15013",
  transform: "translate(6.094 15.234)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_15012",
  "data-name": "Group 15012"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1581",
  "data-name": "Rectangle 1581",
  width: 1.563,
  height: 1.563,
  fill: "#95A1B2",
  stroke: "rgba(0,0,0,0)",
  strokeWidth: 1
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_15015",
  "data-name": "Group 15015",
  transform: "translate(9.219 15.234)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_15014",
  "data-name": "Group 15014"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1582",
  "data-name": "Rectangle 1582",
  width: 1.563,
  height: 1.563,
  fill: "#95A1B2",
  stroke: "rgba(0,0,0,0)",
  strokeWidth: 1
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_15017",
  "data-name": "Group 15017",
  transform: "translate(12.344 15.234)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_15016",
  "data-name": "Group 15016"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1583",
  "data-name": "Rectangle 1583",
  width: 1.563,
  height: 1.563,
  fill: "#95A1B2",
  stroke: "rgba(0,0,0,0)",
  strokeWidth: 1
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_15019",
  "data-name": "Group 15019",
  transform: "translate(15.469 12.109)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_15018",
  "data-name": "Group 15018"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1584",
  "data-name": "Rectangle 1584",
  width: 1.563,
  height: 1.563,
  fill: "#95A1B2",
  stroke: "rgba(0,0,0,0)",
  strokeWidth: 1
}))));

var SvgCalendarIcon = function SvgCalendarIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendarIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar-icon.3b46d3e5.svg";
export { ForwardRef as ReactComponent };